import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Contract, FormDefinitions } from "../../api/dtos";

export interface IContractFormByIdRouteProps extends PropsWithChildren {
    contractId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const ContractFormByIdRoute: FC<IContractFormByIdRouteProps> = ({
    contractId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const contractIdToUse = (params.contractId ? +params.contractId : undefined) ?? contractId ?? undefined;

    const lotId = params.lotId ? +params.lotId : undefined;

    const createData = useMemo(() => new Contract({
        lotId
    }), [lotId]);

    return (
        <ContextFormByIdProvider
            formId={contractIdToUse}
            formDefinitionIdentifier={FormDefinitions.Contract}
            createData={createData}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default ContractFormByIdRoute;
